import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import SpNavi from './SpNavi';
import ToTop from './ToTop';
import Gmap from './Gmap';
import bowser from 'bowser';
import matchheight from 'jquery-match-height';
import inview from 'jquery-inview';
import Swiper from 'swiper';

if(bowser.msie === true) {
	$('body').addClass('ie');
}else if(bowser.msedge === true){
	$('body').addClass('edge');
}else if(bowser.firefox === true){
	$('body').addClass('ff');
}else if(bowser.tablet === true){
	$('body').addClass('tablet');
}
if(bowser.mobile === true){
	$('body').addClass('device--mobile');
	if(bowser.android === true) {
		$('body').addClass('device--mobile--android');
	}
}

let os, ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
	os = "win10";
}
else if (ua.match(/Win(dows )?NT 6\.3/)) {
	os = "win8_1";
}
else if (ua.match(/Win(dows )?NT 6\.2/)) {
	os = "win8";
}
else if (ua.match(/Win(dows )?NT 6\.1/)) {
	os = "win7";
}else{
	os = '';
}

$('body').addClass(os);
/* ===============================================
Check responsive state
=============================================== */
const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
//通常盤
let param = {
	target:'#spnavi',
	trigger:'.btn_sp_navi',
	filter:'resposive_flg',
	speed:200
};
const spnavi = new SpNavi(param);
spnavi.exec();
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
const totop = new ToTop('#totop',100,400);
totop.exec();

/**
 * 外部リンク・PDF・Word・Exlsに_blankの自動付与
 *
 */
const link_icon = require('./link_icon');
link_icon();

const target = '#js-slide';
let options = {
	speed: 1500,
	slidesPerView: 'auto',
	spaceBetween: 0,
	loop:true,
	effect:'fade',
	crossFade: true,
	autoplay:6000
};

$(window).on('load',function(){
	new Swiper(target,options);
	setTimeout(function(){
		$('.swiper').addClass('active');
	},1000);
});

//下層ページ　左コンテンツのFixed処理です。スクロールした時に画面上部に固定します。
$(function($) {
	let area_left = $('#area_fixed'),
		offset = area_left.offset();
	if(area_left.length > 0){
		$(window).scroll(function(){
			if($(window).scrollTop() > offset.top) {
				area_left.addClass('contents-left-fixed');
			} else {
				area_left.removeClass('contents-left-fixed');
			}
		});
	}
});

//indexページの地図画像を少し上に動かしたい
if($('#background-map').length > 0){
	let base_top = 48;
	if(!r.state()()){
		base_top = 0;
	}
	let mapOffset,
		variavle_pos = base_top,
		intro_bg_img = $('.top-intro-text-one-backimage'),
		start_pos,
		current_pos;

	$(window).scroll(function(){
		current_pos = $(this).scrollTop();
		if (current_pos > start_pos) {
			if($(this).scrollTop() > $('.section-top-intro').offset().top) {
				variavle_pos = parseInt(intro_bg_img.css('top'),10) - 1;
				intro_bg_img.css({'top':variavle_pos});
			}
		} else {
			if(variavle_pos !== base_top){
				variavle_pos = parseInt(intro_bg_img.css('top'),10) + 1;
				intro_bg_img.css({'top':variavle_pos});
			}
		}
		start_pos = current_pos;
	});
}

//worksのやっていることの項目をぼんやり出す
let works_modal = $('#works_modal');
works_modal.on('inview',function(event, isInView, visiblePartX, visiblePartY){
	if(isInView){
		works_modal.addClass('modal-on');
	}else {
		works_modal.removeClass('modal-on');
	}
});
let works_modal02 = $('#works_modal02');
works_modal02.on('inview',function(event, isInView, visiblePartX, visiblePartY){
	if(isInView){
		works_modal02.addClass('modal-on');
	}else {
		works_modal02.removeClass('modal-on');
	}
});
let works_modal03 = $('#works_modal03');
works_modal03.on('inview',function(event, isInView, visiblePartX, visiblePartY){
	if(isInView){
		works_modal03.addClass('modal-on');
	}else {
		works_modal03.removeClass('modal-on');
	}
});
let works_modal04 = $('#works_modal04');
works_modal04.on('inview',function(event, isInView, visiblePartX, visiblePartY){
	if(isInView){
		works_modal04.addClass('modal-on');
	}else {
		works_modal04.removeClass('modal-on');
	}
});

//TOPの画像マスク処理
$('.js-cover_img').on('inview',function(event, isInView, visiblePartX, visiblePartY){
	if(isInView){
		$(this).addClass('top-img-on');
	}
});
